import classNames from 'classnames';
import React from 'react';

import BoxLayout from 'sharedreact/components/BoxLayout';
import WebApp from 'sharedreact/data/WebApp';
import ConnectionSupport from 'sharedreact/utils/ConnectionSupport';

import __BUILD_VERSION__ from 'sharedreact/utils/BuildVersion';

type Props = {
  webApp: WebApp,
  small?: boolean,
  active?: boolean
};

class WebAppLink extends React.Component<Props> {
  override render (): React.ReactNode {
    const { webApp, small, active } = this.props;

    const fullUrl: string = ConnectionSupport.createWebAppUrl(webApp.url);

    const size: number = small ? 32 : 128;

    return (
      <div className={classNames('esko_applauncher-applink', {'esko_applauncher-applink-small': small, 'esko_applauncher-applink-active': active})}>
        <a href={fullUrl}>
          <BoxLayout horizontal={small}>
            <div className='esko_applauncher-checkmark'>
              {active
              ? <span className='bi bi-check esko_applauncher-checkmark-color' />
              : null
              }
            </div>
            {webApp.icon != null
              ? <div>
                <img src={webApp.icon + '?v=' + __BUILD_VERSION__} width={size} height={size} />
              </div>
              : null}
            <div>
              <span>{webApp.name}</span>
            </div>
          </BoxLayout>
        </a>
      </div>
    );
  }
}

export default WebAppLink;
